var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm, FormProvider, } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import FormActions from "../FormActions";
import { DocumentFileSchema, FileSchema, REQUIRED_MESSAGE, } from "../../../utils/schemas";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { Button, Stepper, TextField, useStepper } from "@opala-ds/react";
import FileInput from "../../FileInput";
var Schema = z.object({
    funcao: z.string().trim().nonempty(REQUIRED_MESSAGE),
    cref: z.string().trim().nonempty(REQUIRED_MESSAGE),
    cref_arquivo: FileSchema,
    termo_arquivo: DocumentFileSchema,
});
export default function ProfessionalDataForm(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var onSubmit = _a.onSubmit, _k = _a.defaultValues, defaultValues = _k === void 0 ? {
        funcao: "",
        cref: "",
    } : _k;
    var _l = useForm({
        defaultValues: defaultValues,
        resolver: zodResolver(Schema),
    }), watch = _l.watch, handleSubmit = _l.handleSubmit, register = _l.register, _m = _l.formState, errors = _m.errors, formStateRest = __rest(_m, ["errors"]), formRest = __rest(_l, ["watch", "handleSubmit", "register", "formState"]);
    var nextStep = useStepper().nextStep;
    var isMobile = useIsMobile();
    return (_jsx(FormProvider, __assign({ handleSubmit: handleSubmit, register: register, watch: watch, formState: __assign({ errors: errors }, formStateRest) }, formRest, { children: _jsxs("form", __assign({ className: "w-full flex flex-col space-y-12", onSubmit: handleSubmit(function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log(data);
                            return [4 /*yield*/, onSubmit(data)];
                        case 1:
                            _a.sent();
                            nextStep();
                            return [2 /*return*/];
                    }
                });
            }); }) }, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-8 py-8" }, { children: [isMobile && (_jsx("div", __assign({ className: "flex justify-start" }, { children: _jsx(Stepper.Radial, { size: 70, weight: 5 }) }))), _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-4" }, { children: [_jsx(TextField, __assign({ label: "Fun\u00E7\u00E3o", placeholder: "Digite a fun\u00E7\u00E3o", size: "md", helperText: (_c = (_b = errors.funcao) === null || _b === void 0 ? void 0 : _b.message) !== null && _c !== void 0 ? _c : "", variant: errors.funcao ? "critical" : "default" }, register("funcao"))), _jsx(TextField, __assign({ label: "CREF", placeholder: "Digite o CREF", size: "md", helperText: (_e = (_d = errors.cref) === null || _d === void 0 ? void 0 : _d.message) !== null && _e !== void 0 ? _e : "", variant: errors.cref ? "critical" : "default" }, register("cref")))] })), _jsxs("div", __assign({ className: "flex flex-col space-y-4" }, { children: [_jsx("span", __assign({ className: "mb-7 text-sm font-semibold text-[#022A59]" }, { children: "Envio de documentos necess\u00E1rios" })), _jsx(FileInput, __assign({ label: "CREF", accept: ".pdf", defaultValue: (_f = defaultValues.cref_arquivo) === null || _f === void 0 ? void 0 : _f[0] }, register("cref_arquivo"), { error: (_g = errors.cref_arquivo) === null || _g === void 0 ? void 0 : _g.message })), _jsx(FileInput, __assign({ label: "Termo de responsabilidade assinado", accept: ".pdf", defaultValue: (_h = defaultValues.termo_arquivo) === null || _h === void 0 ? void 0 : _h[0] }, register("termo_arquivo"), { error: (_j = errors.termo_arquivo) === null || _j === void 0 ? void 0 : _j.message }))] })), _jsx(Button, __assign({ className: "self-end w-full h-fit p-2 md:p-2 md:w-2/5", leftIcon: "Download", variant: "outline", color: "success", type: "button", size: "md", onClick: function () {
                                return window.open(process.env.TERMOS_JEPIS_PROFESSOR_TECNICO, "_blank");
                            } }, { children: _jsx("span", __assign({ className: "text-sm" }, { children: "Baixar Modelo de Termo de Responsabilidade para Preenchimento" })) }))] })), _jsx(FormActions, {})] })) })));
}
